import { Avatar, List, ListItem, ListItemAvatar, ListItemText } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom';
import placeholder_profile from '../img/avatar.jpg'

const CommunityMembers = ({memberData, admin}) => {
  let members = memberData && Object.keys(memberData);
  let navigate = useNavigate()

  return (
    <div className='member-list'>
      <p style={{textAlign:'center', marginBottom:'0'}}><b className='title' >Members</b></p>
      <List>
        {members && members.map((item, index)=>(
          <ListItem className="member-card" style={{height:"60px"}}key={index} onClick={()=>{navigate(`/profile/${item}`)}}>
            <ListItemAvatar>
              <Avatar src={memberData[item].avatar ? memberData[item].avatar: placeholder_profile} />
            </ListItemAvatar>
            <ListItemText
              primary={memberData[item].username}
              secondary={(item === admin) && 'Admin'}
            />
          </ListItem>
        ))}
      </List>
    </div>

  )
}

export default CommunityMembers